import { ReactNode } from "react";
import { useBoundStore } from "@/app/store";
import { useShallow } from "zustand/shallow";
import { StepperDesktop } from "./Stepper.desktop";
import { StepperMobile } from "./Stepper.mobile";

export interface StepperStep {
  id: string;
  title: string;
  description?: string;
  badge?: string;
  content: ReactNode;
}

export interface StepperProps {
  classNames?: {
    content?: string;
    navigationButtons?: string;
  };
  currentStep: number;
  isDisabled?: boolean;
  nextButtonLabel?: string;
  previousButtonLabel?: string;
  showStepIndicator?: boolean;
  steps: StepperStep[];
  onNext: () => void;
  onPrevious: () => void;
}

export function Stepper(props: StepperProps) {
  const { deviceType } = useBoundStore(useShallow((state) => ({ deviceType: state.device.type })));

  return deviceType === "mobile" ? <StepperMobile {...props} /> : <StepperDesktop {...props} />;
}
